// extracted by mini-css-extract-plugin
module.exports = {"container":"cardDetail_container_2YP74","content":"cardDetail_content_18HV3"};